document.addEventListener("DOMContentLoaded", function () {
    const loader = document.getElementById('page_loader');

    if (loader) {
        // Aligné sur la fin du fondu CSS (loaderFadeOut à 6 s, 0,5 s).
        setTimeout(() => {
            loader.remove();
        }, 6500);
    }
});
